import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../shared/Services/authentication.service";

export const onHoldResolver = () => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  if (auth.getStatus() === 'on_hold') {
    router.navigateByUrl('/dealer-system/dashboard');
    return false;
  }
  return true;
};

